<template>
    <path
        d="M3.37716 6.5002L8.12091 11.244L6.76583 12.599L0.666992 6.5002L6.76583 0.401367L8.12091 1.75645L3.37716 6.5002Z"
        fill="#606060" />
</template>